const cleanStorage = () => {
  const storageKeys = Object.keys(localStorage);
  const keysToClean = storageKeys.filter(key => !key.includes('time_'));

  keysToClean.forEach(key => localStorage.removeItem(key));
}

export default cleanStorage;
